import deCamelize from 'core/helpers/deCamelize'

const formatSelectOption = c => ({
  label: `${c.id} ${c.name ?? deCamelize(c.caseType)}`,
  value: c.id
})

export default formatSelectOption
